import Request from './base/Request';
import * as base64 from 'base-64';

class illegalParkinglotRequest extends Request {
    constructor(APIURL, header) {
        super(APIURL);

        this.options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...header
            },
        };
        this.request = this.request.bind(this);
    }
}

export default illegalParkinglotRequest;